import { IStripePlan } from "../../../interfaces";

export interface ICardTheme {
  dark: boolean;
  featured: boolean;
  topBarGradient: string;
  badgeBg: string;
  badgeColor: string;
  badgeBorder: string;
  scaleBg: string;
  scaleLabelColor: string;
  scaleValueColor: string;
  ctaStyle: "ghost" | "primary" | "green" | "dark";
}

const PALETTES: Omit<ICardTheme, "dark" | "featured">[] = [
  {
    ctaStyle: "ghost",
    topBarGradient: "linear-gradient(90deg, #6c8dc0, #1a3d7c)",
    badgeBg: "#eef2fc",
    badgeColor: "#1a3d7c",
    badgeBorder: "#bfcfe8",
    scaleBg: "linear-gradient(135deg, #eef2fc, #e2eaf8)",
    scaleLabelColor: "#2a5ba8",
    scaleValueColor: "#1a3d7c",
  },
  {
    ctaStyle: "green",
    topBarGradient: "linear-gradient(90deg, #1a3d7c, #30cd73)",
    badgeBg: "#f0fdf4",
    badgeColor: "#166534",
    badgeBorder: "#86efac",
    scaleBg: "linear-gradient(135deg, #f0fdf4, #dcfce7)",
    scaleLabelColor: "#166534",
    scaleValueColor: "#15803d",
  },
  {
    ctaStyle: "primary",
    topBarGradient: "linear-gradient(90deg, #1a3d7c, #2a5ba8)",
    badgeBg: "linear-gradient(135deg, #dde6f5, #eef2fc)",
    badgeColor: "#1a3d7c",
    badgeBorder: "#8aadd6",
    scaleBg: "linear-gradient(135deg, #eef2fc, #dde6f5)",
    scaleLabelColor: "#2a5ba8",
    scaleValueColor: "#1a3d7c",
  },
];

const ENTERPRISE_PALETTE: Omit<ICardTheme, "dark" | "featured"> = {
  ctaStyle: "dark",
  topBarGradient: "linear-gradient(90deg, #30cd73, #1a3d7c)",
  badgeBg: "rgba(48,205,115,0.15)",
  badgeColor: "#30cd73",
  badgeBorder: "rgba(48,205,115,0.25)",
  scaleBg: "rgba(255,255,255,0.06)",
  scaleLabelColor: "rgba(255,255,255,0.40)",
  scaleValueColor: "#ffffff",
};

export const getCardTheme = (plan: IStripePlan, idx: number): ICardTheme => {
  const dark = !!(plan.package?.is_enterprise ?? plan.is_enterprise);
  const featured = !!plan.is_featured;
  if (dark) return { ...ENTERPRISE_PALETTE, dark: true, featured };
  return { ...PALETTES[idx % PALETTES.length], dark: false, featured };
};
